module.exports = __webpack_public_path__ + "img/travel-insurance.f90c0f0.jpg";